import React from 'react';
import { useContext } from 'react';
import { useState } from 'react';
import { createContext } from 'react';

// import { userLogout } from '../store/app/slices/user.slice';
import { useDispatch } from 'react-redux';
import { userLogout } from 'src/store/apps/slices/UserSlice';

const AuthContext = createContext({
  token: '',
  isLoggedIn: false,
  user: {},
  login: (token, user_id) => {},
  logout: () => {},
});

export const AuthProvider = (props) => {
  const initialToken = localStorage.getItem('token');
  const initialUser = localStorage.getItem('user');
  const initialIsLogout = localStorage.getItem('isLogout');
  const [token, setToken] = useState(initialToken);
  const [isLogout, setIsLogout] = useState(initialIsLogout);
  const [user, setUser] = useState(JSON.parse(initialUser));
  const dispatch = useDispatch();

  const loginHandler = (token, user) => {
    setToken(token);
    setUser(user);
    setIsLogout(false);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', token);
    localStorage.setItem('isLogout', false);
  };

  const logoutHandler = () => {
    // dispatch(userLogout()).then((res) => {
    //   setToken(null);
    //   setIsLogout(true);
    //   localStorage.removeItem('user');
    //   localStorage.removeItem('token');
    //   localStorage.removeItem('isLogout');
    // });
  };

  const contextValue = {
    token: token,
    isLoggedIn: !!token,
    user: user,
    isLogout: isLogout,
    login: loginHandler,
    logout: logoutHandler,
  };

  return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
